<script>
import Card from "./Card/Card.vue";

export default {
    name: "ModalDialog",
    components: {
        Card,
    },
    props: {
        title: String,
    },
    data() {
        return {
            visible: false,
        }
    },
    methods: {
        show() {
            this.visible = true
        },
        hide() {
            this.visible = false
        }
    }
}
</script>

<template>
    <div v-show="visible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>

        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <card class="relative transform overflow-hidden shadow-xl transition-all text-left sm:my-8 sm:w-full sm:max-w-4xl">
                    <template slot="header">
                        {{ title }}
                    </template>
                    <div class="p-6">
                        <slot></slot>
                    </div>
                    <template slot="footer">
                        <div class="sm:w-full sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                            <button type="button" @click="$emit('submit')" class="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2">Submit</button>
                            <button type="button" @click="$emit('cancel')" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0">Cancel</button>
                        </div>
                    </template>
                </card>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
